var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "twitter_svg__svg-1204619969-a",
    d: "M13.919 26.88c8.301 0 12.841-6.88 12.841-12.843 0-.195-.004-.39-.013-.583A9.182 9.182 0 0029 11.117a9.022 9.022 0 01-2.592.71 4.53 4.53 0 001.985-2.496 9.044 9.044 0 01-2.866 1.095 4.515 4.515 0 00-7.692 4.116A12.814 12.814 0 018.53 9.828a4.498 4.498 0 00-.611 2.268 4.51 4.51 0 002.009 3.757 4.48 4.48 0 01-2.045-.564v.057a4.516 4.516 0 003.62 4.425 4.527 4.527 0 01-2.038.078 4.519 4.519 0 004.217 3.135 9.057 9.057 0 01-5.606 1.932A9.18 9.18 0 017 24.852a12.778 12.778 0 006.919 2.028"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "twitter_svg__svg-1204619969-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#twitter_svg__svg-1204619969-a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#twitter_svg__svg-1204619969-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6h32v32H6z"
  })))));
}

export default SvgTwitter;